import React, { useEffect } from "react";
import { useStateValue } from "../../../StateProvider";
import axios from "../../../axios"

const BasketPriceUpdater = () => {
const [{basket},dispatch]=useStateValue()
  useEffect(() => {
    const updatePrices = async () => {
      try {
        const productIds = basket.map((item) => item.id);
        const response=axios({
          url:'/products/get/update-price',
          method:'post',
          headers: { "Content-Type": "application/json" },
          data:productIds
        })
        const latestPrices = await response;

        await latestPrices.data.forEach(({ _id, price }) => {
          const basketItem = basket.find((item) => item.id === _id);
          if (basketItem && basketItem.price !== price) {
            dispatch({ type: "UPDATE_PRODUCT_PRICE", payload: { _id, newPrice: price } });
          }
        });
      } catch (error) {
        console.error("Error fetching or updating prices:", error);
      }
    };

    if (basket.length > 0) {
      updatePrices();
    }
  }, [basket, dispatch]);

  return null;
};

export default BasketPriceUpdater;
